import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'

import { router } from '@/app/routes'
import { queryClient } from '@/lib/query/query-client'
import { AuthProvider } from '@/lib/auth/auth-provider'
import { OrganizationProvider } from '@/lib/org/org-provider'
import { ThemeProvider } from '@/lib/theme/theme-provider'
import '@/index.css'

const container = document.getElementById('root')
if (!container) {
  throw new Error('Root element #root is missing from index.html')
}

// Provider order is load-bearing: OrganizationProvider issues a query and reads
// the session, so it must sit inside both QueryClientProvider and AuthProvider.
createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <OrganizationProvider>
            <RouterProvider router={router} />
          </OrganizationProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
)
